import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { storiesAPI } from '../services/api';
import { useProfile } from '../context/ProfileContext';

export default function StoriesScreen() {
  const navigate = useNavigate();
  const { profile } = useProfile();
  const [stories, setStories] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState('my'); // 'my' | 'interactive'

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const [storiesData, templatesData] = await Promise.all([
        profile ? storiesAPI.getAll(profile.id) : [],
        storiesAPI.getTemplates()
      ]);
      setStories(storiesData);
      setTemplates(templatesData);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const deleteStory = async (storyId, e) => {
    e.stopPropagation();
    if (window.confirm('Delete this story?')) {
      await storiesAPI.delete(profile.id, storyId);
      setStories(prev => prev.filter(s => s.id !== storyId));
    }
  };

  return (
    <div className="screen">
      <div className="screen-header" style={{ background: 'linear-gradient(135deg, #FECA57, #FF9F43)', paddingBottom: 16 }}>
        <button className="btn-back" onClick={() => navigate('/')} style={{ background: 'rgba(255,255,255,0.3)', color: 'var(--dark)' }}>←</button>
        <div style={{ flex: 1 }}>
          <h1 style={{ fontFamily: 'var(--font-title)', color: 'var(--dark)', fontSize: '1.5rem' }}>📚 Stories</h1>
          <p style={{ fontSize: '0.8rem', color: 'rgba(0,0,0,0.6)' }}>Read & write adventures!</p>
        </div>
        <button className="btn btn-sm btn-primary" onClick={() => navigate('/stories/builder')}>
          ✍️ Write
        </button>
      </div>

      {/* Tabs */}
      <div style={{ display: 'flex', padding: '12px 20px 0', gap: 8 }}>
        {[['my', '📖 My Stories'], ['interactive', '🎮 Interactive']].map(([id, label]) => (
          <button
            key={id}
            onClick={() => setTab(id)}
            style={{
              flex: 1, padding: '10px 16px', border: 'none', borderRadius: 12,
              background: tab === id ? 'var(--purple)' : 'var(--bg)',
              color: tab === id ? 'white' : 'var(--gray)',
              fontFamily: 'var(--font-body)', fontWeight: 700, cursor: 'pointer',
              fontSize: '0.85rem'
            }}
          >
            {label}
          </button>
        ))}
      </div>

      <div className="screen-body" style={{ paddingTop: 16 }}>
        {loading ? (
          <div style={{ textAlign: 'center', padding: 40 }}>
            <div className="spinner" style={{ margin: '0 auto' }} />
          </div>
        ) : tab === 'my' ? (
          <>
            {stories.length === 0 ? (
              <div style={{ textAlign: 'center', padding: '40px 20px' }}>
                <div style={{ fontSize: '4rem', marginBottom: 12 }}>📝</div>
                <h3 style={{ fontFamily: 'var(--font-title)', marginBottom: 8 }}>No stories yet!</h3>
                <p style={{ color: 'var(--gray)', marginBottom: 20 }}>Start writing your first amazing story</p>
                <button className="btn btn-primary" onClick={() => navigate('/stories/builder')}>
                  ✍️ Write My First Story
                </button>
              </div>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                {stories.map(story => (
                  <div
                    key={story.id}
                    className="card card-clickable"
                    onClick={() => navigate(`/stories/builder/${story.id}`)}
                    style={{ display: 'flex', gap: 14 }}
                  >
                    <div style={{ width: 60, height: 60, borderRadius: 12, background: 'linear-gradient(135deg, #FECA57, #FF9F43)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.8rem', flexShrink: 0 }}>
                      📖
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontWeight: 800, marginBottom: 2 }}>{story.title}</div>
                      <div style={{ color: 'var(--gray)', fontSize: '0.8rem' }}>
                        {story.word_count} words · {new Date(story.created_at).toLocaleDateString()}
                      </div>
                    </div>
                    <button
                      onClick={(e) => deleteStory(story.id, e)}
                      style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--red)', fontSize: '1.1rem', padding: '0 4px' }}
                    >
                      🗑️
                    </button>
                  </div>
                ))}
              </div>
            )}
          </>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {templates.map(template => (
              <div
                key={template.id}
                className="card card-clickable"
                style={{ background: template.coverColor + '11', border: `2px solid ${template.coverColor}33` }}
                onClick={() => alert('Interactive story coming soon! 🚀')}
              >
                <div style={{ fontFamily: 'var(--font-title)', fontSize: '1.1rem', marginBottom: 4 }}>{template.title}</div>
                <div style={{ color: 'var(--gray)', fontSize: '0.85rem', marginBottom: 10 }}>{template.description}</div>
                <button className="btn btn-sm btn-primary" style={{ alignSelf: 'flex-start' }}>
                  Start Reading ▶
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
